import _ from 'lodash';

import { DomainError } from 'src/models/DomainError';
import { GetCustomAttributesStore } from './getCustomAttributesStore';

export function ValidateItemIsNotDuplicate(item) {
  const storeValues = GetCustomAttributesStore() || [];
  const errors: DomainError[] = [];
  storeValues.forEach(storeItem => {
    if (storeItem.id === item.id) return;
    if (storeItem.label.toLowerCase() === _.trim(item.label).toLowerCase()) {
      errors.push({
        code: 'taken',
        attr: 'label',
        detail:
          'This display name already exists. Choose a different display name and try again. Keep in mind the display names are not case sensitive.',
      });
    }
    if (storeItem.key.toLowerCase() === _.trim(item.key).toLowerCase()) {
      errors.push({
        code: 'taken',
        attr: 'key',
        detail:
          'This key already exists. Choose a different key and try again. Keep in mind the keys are not case sensitive.',
      });
    }
  });
  return errors;
}
